import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import Pagination from "../../../../../../../components/NTable/Pagination";
import SimpleTable from "../../../../../../../components/SimpleTable";
import Button from "../../../../../../../components/Button";
import Search from "./Search";
import { useColumns } from "./useColumns";

const perPage = 10;

function Table({ name, filteredData, setFilteredData, data, setData }) {
    const { t } = useTranslation();
    const [page, setPage] = useState(0);
    const columns = useColumns({ name, setData, setFilteredData });
    const removeAll = useCallback(() => {
        setData([]);
        setFilteredData([]);
    }, [setData, setFilteredData]);

    return (
        <div className="h-100">
            <div className="d-flex align-items-center mb-3 gap-2 w-100">
                <Search defaultData={data} setFilteredData={setFilteredData} />

                <Button
                    className="w-25 px-2"
                    color="danger"
                    onClick={removeAll}

                >
                    {t("remove-all")}
                </Button>
            </div>

            <div style={{ minHeight: "250px", maxHeight: "calc(100% - 500px)", overflow: "auto" }}>
                <SimpleTable
                    columns={columns}
                    data={filteredData.slice(page * perPage, Number((page * perPage) + perPage))}
                    totalItems={filteredData.length}
                    footer={false}
                />
            </div>

            <Pagination
                page={page}
                perPage={perPage}
                totalItems={filteredData.length}
                pageCount={Math.ceil(filteredData.length / perPage)}
                gotoPage={setPage}
                showOnSizeChange={false}
            />
        </div>
    );
}

export default Table;
